import { render } from "./ImageModal.vue?vue&type=template&id=fe2ed534"
import script from "./ImageModal.vue?vue&type=script&lang=js"
export * from "./ImageModal.vue?vue&type=script&lang=js"

import "./ImageModal.vue?vue&type=style&index=0&id=fe2ed534&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__